import { useDisclosure } from '@mantine/hooks';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logger } from 'utils/logger';
import { getScanStatusColor, getStatusColor, getUserAvatarColour, getUserInitials } from 'utils/helper';
import { getScan } from 'services/scanService';
import { IconShirt } from '@tabler/icons-react';
import ResolverImage from '../resolverImage/ResolverImage';
import Moment from 'react-moment';
import { DataFormats } from 'utils/constants';
import moment from 'moment';

const { Popover, Text, Group, Button, createStyles, Box, Badge, Avatar, Image } = require('@mantine/core');

const useStyles = createStyles((theme) => ({
    card: {
        //   margin:-theme.spacing.md,
        padding: 0,
        position: 'relative',
    },

    imageSection: {
        padding: theme.spacing.md,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderBottom: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
    },

    label: {
        marginBottom: theme.spacing.xs,
        lineHeight: 1,
        fontWeight: 700,
        fontSize: theme.fontSizes.xs,
        //   letterSpacing: -0.25),
        textTransform: 'uppercase',
    },

    section: {
        paddingTop: theme.spacing.md,
        paddingBottom: theme.spacing.md,
        borderTop: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
        margin: 0,
    },

    icon: {
        color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
    },
}));

const ScanPopover = (props) => {
    const [opened, { close, open }] = useDisclosure(false);
    const [data, setData] = useState();
    const { classes } = useStyles();
    const popRef = useRef();
    const doClose = useRef(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (opened) {
            logger.log(props.data, data);
            async function fetchSample() {
                const val = await getScan(props.data.id);
                // setData(val);
                setData({ ...props.data, ...val });
            }
            // fetch the sample
            if (!data || (data && data.id !== props.data.id && opened)) fetchSample();
        }
    }, [opened]);

    const mouseHandler = (e) => {
        setTimeout(() => {
            if (doClose.current) {
                close();
                doClose.current = true;
            }
        }, 200);
    };

    logger.log('data', data);

    const showDetails = () => {
        logger.log(props.data)
        navigate(`/warehouse/scans/${props.data.id}`);
        props.onShowDetails();
    };

    return (
        <Popover withinPortal={true} width={300} position='bottom-end' withArrow shadow='md' opened={opened}>
            <Popover.Target>
                <div ref={popRef} onMouseEnter={open} onMouseLeave={(e) => mouseHandler(e)}>
                    {props.children}
                </div>
            </Popover.Target>

            <Popover.Dropdown sx={{ pointerEvents: 'initial' }}>
                {data ? (
                    <Box
                        className={classes.card}
                        style={{ padding: 0 }}
                        onMouseLeave={() => {
                            close();
                            doClose.current = true;
                        }}
                        onMouseEnter={() => {
                            open();
                            doClose.current = false;
                        }}>
                            
                        <Box className={classes.imageSection}>
                            {/* <Image src="https://i.imgur.com/ZL52Q2D.png" />
                            <IconShirt size={72} stroke={1} /> */}
                            <ResolverImage eager width={180} height={180} src={props.data.url} />
                        </Box>

                        <Group position='apart' my='md'>
                            <div style={{width:270}}>
                                <Text fw={500} truncate style={{textWrap:'wrap', wordWrap:'normal'}}>{data?.id}</Text>
                                <Text color='dimmed' size={'sm'} lineClamp={2}>
                                    {data?.barcode}
                                </Text>
                            </div>
                            <Badge color={getScanStatusColor(data?.extractStatus)} variant='light'>
                                {data?.extractStatus}
                            </Badge>
                        </Group>

                        
                        <Box className={classes.section}>
                            <Group position='apart'>
                                <div>
                                    <Text size='xs' color='dimmed'>
                                        Location
                                    </Text>
                                    <Text weight={500} size='sm'>
                                        {data?.location??'-'}
                                    </Text>
                                </div>
                                <div>
                                    <Text size='xs' color='dimmed'>
                                        Scanned
                                    </Text>
                                    <Text weight={500} size='sm'>
                                        {moment(data?.scanned).format(DataFormats.DATE_FORMAT_SHORT)}
                                    </Text>
                                </div>
                                <div>
                                    <Text size='xs' color='dimmed'>
                                        Feed Reference
                                    </Text>
                                    <Text weight={500} size='sm'>
                                        {data?.feedReference??'-'}
                                    </Text>
                                </div>
                            </Group>
                        </Box>
                        <Box className={classes.section}>
                            <Group spacing={30}>
                                <Button style={{ flex: 1 }} onClick={showDetails}>
                                    View Details
                                </Button>
                            </Group>
                        </Box>
                    </Box>
                ) : (
                    <Box>
                        <Text size={'sm'} color='dimmed'>
                            There is no event information available
                        </Text>
                    </Box>
                )}
            </Popover.Dropdown>
        </Popover>
    );
};

export default ScanPopover;
